import { isDefined } from "@clipboard-health/util-ts";
import { Button, CardActions, Chip } from "@mui/material";
import { useDeleteShiftInvite } from "@src/appV2/ShiftInvites/api/useDeleteShiftInvite";

import { ShiftInviteStatus } from "../ShiftInvites/type";
import { CbhCustomChatMessage } from "./CbhCustomChatMessage";
import { type RenderCustomMessageProps } from "./type";
import { parseShiftInviteChatMessage } from "./utils";

const shiftInviteStatusToColor: Record<string, "default" | "error" | "success"> = {
  EXPIRED: "default",
  ACCEPTED: "success",
  DECLINED: "error",
};

export function ShiftInviteRequestMessage(props: RenderCustomMessageProps) {
  const { shiftInviteId, status, facilityMessage } = parseShiftInviteChatMessage(props);
  const { mutateAsync: deleteShiftInviteMutate, isLoading: isDeletingShiftInvite } =
    useDeleteShiftInvite();

  if (!isDefined(facilityMessage) || status === ShiftInviteStatus.DELETED) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <CbhCustomChatMessage message={facilityMessage}>
      <CardActions>
        {status === ShiftInviteStatus.PENDING && isDefined(shiftInviteId) && (
          <Button
            size="small"
            variant="contained"
            sx={{ width: "100%" }}
            disabled={isDeletingShiftInvite}
            onClick={async () => {
              await deleteShiftInviteMutate(shiftInviteId);
            }}
          >
            Remove Invite
          </Button>
        )}
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison */}
        {isDefined(status) && status !== ShiftInviteStatus.PENDING && (
          <Chip
            label={status.toUpperCase()}
            sx={{ width: "100%" }}
            color={shiftInviteStatusToColor[status.toUpperCase()]}
            variant="outlined"
          />
        )}
      </CardActions>
    </CbhCustomChatMessage>
  );
}
